// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import type { SxProps } from '@mui/material/styles';
import React from 'react';
import { CardMedia } from '../../../lib/base';
import type { Theme } from '../../../theme/Theme';

interface Props {
  readonly imageUrl: string;
  readonly altText: string;
  readonly title?: string;
  readonly width: number;
  readonly height: number;
  readonly sx?: SxProps<Theme>;
  readonly eager?: boolean;
}

export default function Image({ sx, imageUrl, altText, height, width, eager, title }: Props) {
  const webpUrl = imageUrl.replace(/\.(jpe?g|png)$/i, '.webp');

  return (
    <picture>
      <source srcSet={webpUrl} type="image/webp" />
      <source srcSet={imageUrl} type="image/jpeg" />
      <CardMedia
        component="img"
        loading={eager ? 'eager' : 'lazy'}
        image={imageUrl}
        alt={altText}
        width={width}
        height={height}
        title={title ?? altText}
        sx={[...(Array.isArray(sx) ? sx : [sx])]}
      />
    </picture>
  );
}
